import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faCrown } from "@fortawesome/free-solid-svg-icons"

export const Crown = (props) => {
  return <FontAwesomeIcon faIcon={faCrown} {...props} />
}
